import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withNamespaces } from "react-i18next"
import actions from './actions/root_action'
import Listing from "./listing"
import './property_listings.scss'

export class PropertyListings extends Component {
  componentDidMount() {
    const { namespace, query } = this.props
    this.props.actions.search.getRoomGroups(namespace, query)
  }

  componentDidUpdate(prevProps) {
    if (this.props.search != prevProps.search) {
      this.initSwiper()
      window.addEventListener('resize', this.initSwiper)
    }
  }

  componentWillUnmount() {
    this.swiper && this.swiper.destroy(true, true)
  }

  initSwiper = () => {
    const options = {
      slidesPerView: 4,
      spaceBetween: 16,
      breakpoints: {
        1079: {
          slidesPerView: 2,
          spaceBetween: 16
        },
        559: {
          slidesPerView: 1,
          spaceBetween: 10
        }
      },
      navigation: {
        prevEl: this.prevEl,
        nextEl: this.nextEl
      }
    }

    if (this.el && !this.swiper) {
      /* global Swiper */
      this.el.setAttribute('data-state', 'initialized')
      this.swiper = new Swiper(this.el, options)
    }

    setTimeout(() => {
      const slide = this.el.querySelector('.js-swiper-slide-image')
      if (slide) {
        const buttonTop = slide.clientHeight / 2 + 16 + 'px'
        this.prevEl.style.top = buttonTop
        this.nextEl.style.top = buttonTop
      }
    })
  }

  get roomGroups() {
    return (this.props.search && this.props.search.room_groups) || []
  }

  get linkParams() {
    return {
      ...this.props.query,
      country_code: undefined,
      limit: undefined,
      sort: undefined
    }
  }

  render() {
    const { t } = this.props
    return (
      <section styleName="property-listings">
        <div styleName="content">
          <h2 styleName="property-heading">{this.props.heading}</h2>
          <div className="swiper-custom-parent">
            <div styleName="" className="js-swiper swiper-container swiper-container-horizontal" data-swiper-id="vietnam" ref={el => (this.el = el)}>
              <ul styleName="listing-container" className="swiper-wrapper linear">
                { this.roomGroups.map(roomGroup => <Listing roomGroup={roomGroup} key={roomGroup.id} />) }
              </ul>
            </div>
            <div className="js-swiper-button-prev swiper-button-prev swiper-button-disabled" styleName="" tabIndex="0" role="button" aria-label="Previous slide" aria-disabled="true" ref={el => (this.prevEl = el)}>
              <span className="inner-arrow"></span>
            </div>
            <div className="js-swiper-button-next swiper-button-next" styleName="" tabIndex="0" role="button" aria-label="Next slide" aria-disabled="false" ref={el => (this.nextEl = el)}>
              <span className="inner-arrow"></span>
            </div>
          </div>
          {
            this.props.disableMoreLink || <a styleName="see-more" href={routeUrlHelper.countrySearchPath('vn', this.linkParams)}>{t('vietnam.more')}</a>
          }
        </div>
      </section>
    )
  }
}

const mapStateToProps = (state, { namespace }) => {
  return {
    login: state.login,
    language: state.language,
    modal: state.modal,
    search: state[namespace]
  }
}

const mapDispatchToProps = (dispatch, state) => {
  return {
    actions: actions(dispatch)
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withNamespaces('vietnam')
)(PropertyListings)
